import { isPresent, isUndefined } from '@whisklabs/typeguards';
import { fractions } from './fractions';
import { dropZeros, getFractions } from './number';
import { isCapitalizableUnit, isFractionalUnit, isWithoutSpaceUnit } from './units';
export var formatQuantity = function (quantity, unit) {
    if (isUndefined(unit) || !isFractionalUnit(unit)) {
        return dropZeros(quantity).toString();
    }
    var fraction = getFractions(quantity);
    if (isUndefined(fraction)) {
        return dropZeros(quantity).toString();
    }
    var int = fraction[0], num = fraction[1], den = fraction[2];
    var showInt = int !== 0;
    var showFraction = num !== 0;
    if (!showInt && !showFraction) {
        return '0';
    }
    return [showInt ? int : undefined, showFraction ? formatFraction(num + "/" + den) : undefined]
        .filter(isPresent)
        .join(' ');
};
export var formatUnit = function (unit) {
    if (isCapitalizableUnit(unit)) {
        return "" + unit[0].toUpperCase() + unit.slice(1);
    }
    return unit;
};
export var formatQtyUnit = function (item) {
    if (isPresent(item.quantity) && isPresent(item.unit) && isWithoutSpaceUnit(item.unit)) {
        return "" + formatQuantity(item.quantity, item.unit) + item.unit;
    }
    return [
        isPresent(item.quantity) ? formatQuantity(item.quantity, item.unit) : undefined,
        isPresent(item.unit) ? formatUnit(item.unit) : undefined,
    ]
        .filter(isPresent)
        .join(' ');
};
export var formatFraction = function (fraction) { var _a; return (_a = fractions[fraction]) !== null && _a !== void 0 ? _a : fraction; };
//# sourceMappingURL=format.js.map